import React, { useState } from 'react'
import G from '../../../../../../util/globalFunction'

export default props => {
    const { requesterUserInfo, popupData, setPopupData, mobileNumRef, emailRef } = props || {
        requesterUserInfo: {},
        popupData: {},
    }

    //값 변경
    const handleChangeData = e => {
        let param = { ...popupData }
        param[e.target.name] = e.target.value
        setPopupData(param)
    }

    return (
        <div className="my_page">
            <h5 className="tt_type3">
                {G.t('trem.lang.home.0802')}
                {/* 안내 */}
            </h5>
            <div
                className="mb-6"
                style={{
                    width: '100%',
                    padding: '15px',
                    textAlign: 'center',
                    fontSize: '16px',
                    color: '#df3128',
                    border: '1px solid #d9d9d9',
                }}
            >
                {G.t('trem.lang.home.0803')}
                {/* 견적 요청 목적을 작성해 주시면 정확한 견적서 작성에 도움이 됩니다. */}
            </div>
            <h5 className="tt_type3">{G.t('trem.lang.home.0804')}</h5> {/* 신청자 정보 */}
            <div className="mb-6">
                <table className="table_type2">
                    <caption>견적요청하기 팝업 신청자 정보 표 - 신청자, 소속, 연락처, 이메일로 구성</caption>
                    <tbody>
                        <tr>
                            <th scope="row">{G.t('trem.lang.home.0174')}</th>{/* 신청자 */}
                            <td>{requesterUserInfo?.NAME}</td>
                        </tr>
                        <tr>
                            <th scope="row">{G.t('trem.lang.home.0038')}</th>{/* 소속 */}
                            <td>{requesterUserInfo?.CDTYPE_NAME}</td>
                        </tr>
                        <tr>
                            <th scope="row"><label htmlFor="REQUESTER_MOBILE_NO">{G.t('trem.lang.home.0050')}</label></th>{/* 연락처 */}
                            <td>
                                <input
                                    ref={mobileNumRef}
                                    title="연락처 입력"
                                    type="text"
                                    name="REQUESTER_MOBILE_NO"
                                    id="REQUESTER_MOBILE_NO"
                                    value={popupData?.REQUESTER_MOBILE_NO}
                                    onChange={handleChangeData}
                                />
                            </td>
                        </tr>
                        <tr>
                            <th scope="row"><label htmlFor="REQUESTER_EMAIL">{G.t('trem.lang.home.0212')}</label></th>{/* 이메일 */}
                            <td>
                                <input
                                    ref={emailRef}
                                    title="이메일 입력"
                                    type="text"
                                    name="REQUESTER_EMAIL"
                                    id="REQUESTER_EMAIL"
                                    value={popupData?.REQUESTER_EMAIL}
                                    onChange={handleChangeData}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <h5 className="tt_type3">
                <label htmlFor="REQURIEMENT">{G.t('trem.lang.home.0805')}</label>{/* 견적 요청 목적 */}
            </h5>
            <div>
                <textarea title="견적 요청 목적" name="REQURIEMENT" id="REQURIEMENT" className="textarea1" onChange={handleChangeData}>
                    {popupData?.REQURIEMENT}
                </textarea>
            </div>
        </div>
    )
}
